import {React, useEffect, useState, Fragment} from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import {Paper, Grid, Typography, TextField, MenuItem, Zoom, Table, TableBody, TableHead, TableContainer, TableCell, TableRow, 
        Fab, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Switch, Checkbox, IconButton, CircularProgress} from '@material-ui/core/'
import {DatePicker} from '@material-ui/pickers';        
import AddIcon from '@material-ui/icons/Add';
import {authFetch, logout} from '../../auth';

import DoneIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import DehazeIcon from '@material-ui/icons/Dehaze';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import AssessmentIcon from '@material-ui/icons/Assessment';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import DateRangeIcon from '@material-ui/icons/DateRange';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { TrainRounded } from '@material-ui/icons';
import DragHandleIcon from '@material-ui/icons/DragHandle';
import ArrowDropDownCircleIcon from '@material-ui/icons/ArrowDropDownCircle';
import DonutLargeIcon from '@material-ui/icons/DonutLarge';


const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.main,
      padding: 3
    },
    body: {
      fontSize: 14,
      color: theme.palette.primary.dark,
      padding: 5,
      backgroundColor: 'white'
    },
  }))(TableCell);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: theme.spacing(2)
    },
    darkText: {
        color: theme.palette.primary.main
    },
    contentPaper:{
        background: theme.palette.secondary.light,
        padding: 10,
    },
    searchButton:{
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.secondary.main,
        borderRadius: 8,
        fontSize: 29,
        "&:hover": {
            backgroundColor: theme.palette.primary.dark,            
        },                
    },
    sectionTitle: {
        marginBottom: 10,
        backgroundColor: theme.palette.secondary.light,
        borderRadius: 3,
        color: theme.palette.primary.dark
    },
    componentTitle: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.secondary.main,
        padding: 2,
        borderRadius: 10,
        marginBottom: theme.spacing(1)
    },
    formPaper: {
        padding: theme.spacing(3),
        color: theme.palette.primary.main,
        "> * + *": {
            marginTop: theme.spacing(5)
        }
    }, 
    formRow: {
        width: "100%",       
        maxHeight: "50%",        
    },
    labelText: {
        color: theme.palette.primary.main,
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 16 
    },
    dialogContent: {
        fontSize: 14,
        color: theme.palette.primary.main,
    },
    dialogTitle: {
        fontSize: 14,
        color: theme.palette.primary.main,
        fontWeight: 'normal'
    },    
    formText: {
        fontSize: 14,
        color: theme.palette.primary.main,
        textAlign: "center",
        background: 'white',        
    },
    formDefined: {
        backgroundColor: theme.palette.secondary.light,        
    },
    formItem: {
        fontSize: theme.typography.subtitle1.fontSize,
        fontWeight: 'normal',
        color: theme.palette.primary.dark
    },
    formDateText: {
        fontSize: 14,
        color: theme.palette.primary.main,
        textAlign: "left",
    },
    formItemNoPadding: {
        padding: 0
    },
    uploadButton : {
        fontSize: 14,
        [theme.breakpoints.down('xs')]: {
          fontSize: 8,
        },
    }
  }));

// Helper para calcular el número de semanas (Lunes a Domingo) de un mes
const getWeeksInMonth = (date) => {
    if (!date) return 4;
    const year = date.getFullYear();
    const month = date.getMonth(); // 0-indexed
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);

    let weeksCount = 0;
    let current = new Date(firstDay);

    while (current <= lastDay) {
        if (current.getDay() === 0 || current.getTime() === lastDay.getTime()) {
            weeksCount++;
        }
        current.setDate(current.getDate() + 1);
    }

    return weeksCount;
};

export default function Summary(props) {
    const classes = useStyles(); 
    let billingDate = props.billingDate;
    
    const [feedbackDialog, setFeedbackDialog] = useState(false); 
    const [feedbackMsg, setFeedbackMsg] = useState("");    
    const [internalReportStatus, setInternalReportStatus] = useState({});
    
    const [generationInProgress, setGenerationInProgress] = useState(false);
    const [downloadInProgress, setDownloadInProgress] = useState(false);

    const [genCed01InProgress, setGenCed01InProgress] = useState(false);
    const [downCed01InProgress, setDownCed01InProgress] = useState(false);

    const [downloadingWeek, setDownloadingWeek] = useState(null);

    // Estados de descarga para los 5 nuevos reportes de anexos y cierre
    const [loadingAnexoBolsa, setLoadingAnexoBolsa] = useState(false);
    const [loadingAnexoConsumos, setLoadingAnexoConsumos] = useState(false);
    const [loadingAnexoContratos, setLoadingAnexoContratos] = useState(false);
    const [loadingAnexoGeneracion, setLoadingAnexoGeneracion] = useState(false);
    const [loadingReporteCierre, setLoadingReporteCierre] = useState(false);
    const [loadingInformacionFinanciera, setLoadingInformacionFinanciera] = useState(false);

    const handleFeedbackDialogOpen = () => { setFeedbackDialog(true); };
    const handleFeedbackDialogClose = () => { setFeedbackDialog(false); };

    const checkReportsStatus = () => {
        authFetch("/api/check-internal-reports-status?username=" + String(props.username) +
            "&year=" + billingDate.getFullYear() + "&month=" + String(billingDate.getMonth() + 1) +
            "&version=" + props.tariffCalcVersion)
        .then(response => {
            if (response.status === 422) { logout(); return null; }
            return response.json();
        })
        .then(response => {
            if (response && response.reports_status) {
                setInternalReportStatus(response.reports_status);
            }
        });
    };

    const callReportGeneration = (code) => {
        if (code === 'ced01') setGenCed01InProgress(true);
        else setGenerationInProgress(true);
                    
        authFetch("/api/generate-internal-report?username=" + String(props.username) +
            "&year=" + billingDate.getFullYear() + "&month=" + String(billingDate.getMonth() + 1) +
            "&code=" + code + "&version=" + props.tariffCalcVersion + "&user_type=" + props.userType)
        .then(response => {
            if (response.status === 422) { logout(); return null; }
            else if (response.status !== 200) {
                handleFeedbackDialogOpen();
                setFeedbackMsg("Error en el proceso de generación.");    
                setGenerationInProgress(false);
                setGenCed01InProgress(false);
                return null;
            }
            return response.json();
        })
        .then(response => {             
            if (response && response.Upload === 'OK') {
                handleFeedbackDialogOpen();
                setFeedbackMsg("Reporte " + (code === 'ced01' ? '01 Cedenar' : code) + " generado correctamente.");    
                setGenerationInProgress(false);       
                setGenCed01InProgress(false);
                checkReportsStatus();
            }            
        });
    };

    const downloadReport = (code) => {
        if (code === 'ced01') setDownCed01InProgress(true);
        else setDownloadInProgress(true);

        authFetch("/api/download-report-file?username=" + String(props.username) +
            "&year=" + billingDate.getFullYear() + "&month=" + String(billingDate.getMonth() + 1) +
            "&code=" + code + "&timestamp=" + new Date().toISOString().slice(0,19)
            + '&version=' + props.tariffCalcVersion
            , { responseType: 'blob' })
        .then(response => {
            if (response.status === 422) { logout(); return null; }
            else if (response.status !== 200) {
                handleFeedbackDialogOpen();
                setFeedbackMsg("Error en la descarga del reporte.");    
                setDownloadInProgress(false);
                setDownCed01InProgress(false);
                return null;
            }
            return response.blob();
        })
        .then(blob => {                 
            setDownloadInProgress(false);
            setDownCed01InProgress(false);
            
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;    
            
            if (code === 'ced01') {
                a.download = '01_Cedenar_' + props.username + '_' + billingDate.getFullYear() + '_' + String(billingDate.getMonth() + 1) + '.xlsx';
            } else {
                a.download = 'Reporte_001_' + props.username + '_' + billingDate.getFullYear() + '_' + String(billingDate.getMonth() + 1) + '.csv';
            }
            
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);                                                                          
        });
    };

    const downloadMemSemReport = (weekNumber) => {
        setDownloadingWeek(weekNumber);

        const year = billingDate.getFullYear();
        const month = billingDate.getMonth() + 1;

        authFetch(`/api/download-mem-sem-report?username=${String(props.username)}&year=${year}&period=${month}&version=${props.tariffCalcVersion}&portfolio=${props.portfolio || 'Ecopetrol'}&subportfolio=${props.subportfolio || 'Modelo 4'}&week=${weekNumber}&timestamp=${new Date().toISOString().slice(0,19)}`, 
        { responseType: 'blob' })
        .then(response => {
            if (response.status === 422) { logout(); return null; }
            else if (response.status !== 200) {
                handleFeedbackDialogOpen();
                setFeedbackMsg(`Error al descargar la Semana ${weekNumber}.`);    
                setDownloadingWeek(null);
                return null;
            }
            return response.blob();
        })
        .then(blob => {                 
            setDownloadingWeek(null);
            if (!blob) return;

            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;    
            a.download = `Reporte_MEM_Semana_${weekNumber}_${year}${month < 10 ? '0' + month : month}.xlsx`;
            
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);                                                                          
        });
    };

    // Función genérica para descargar anexos y el reporte de cierre
    const downloadAnexoReport = (endpoint, setProgress, defaultFileName) => {
        setProgress(true);

        const year = billingDate.getFullYear();
        const month = billingDate.getMonth() + 1;

        const urlParams = new URLSearchParams({
            username: String(props.username),
            year: year,
            period: month,
            version: props.tariffCalcVersion,
            portfolio: props.portfolio || 'Ecopetrol',
            subportfolio: props.subportfolio || 'Modelo 4',
            timestamp: new Date().toISOString().slice(0,19)
        });

        authFetch(`/api/${endpoint}?${urlParams.toString()}`, { responseType: 'blob' })
        .then(response => {
            if (response.status === 422) { logout(); return null; }
            else if (response.status !== 200) {
                handleFeedbackDialogOpen();
                setFeedbackMsg(`Error en la descarga del reporte: ${defaultFileName}`);    
                setProgress(false);
                return null;
            }
            return response.blob();
        })
        .then(blob => {                 
            setProgress(false);
            if (!blob) return;

            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;    
            a.download = `${defaultFileName}_${year}${month < 10 ? '0' + month : month}.xlsx`;
            
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);                                                                          
        });
    };

    useEffect(() => {
        document.title = "Reportes internos"; 
        checkReportsStatus();              
    }, [props.billingDate]);

    const showFeedbackDialog = () => (
        <Dialog open={feedbackDialog} onClose={handleFeedbackDialogClose}>
            <DialogTitle className={classes.dialogTitle} style={{ textAlign: 'center' }}>Aviso</DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <DialogContentText>{feedbackMsg}</DialogContentText>
            </DialogContent>
            <DialogActions>          
                <Button onClick={handleFeedbackDialogClose} color="primary" autoFocus>Aceptar</Button>
            </DialogActions>
        </Dialog>
    );

    const weeksInCurrentMonth = getWeeksInMonth(billingDate);

    return (
        <div className={classes.root}>            
            {showFeedbackDialog()}
            <Zoom in timeout={800}>
                <Grid container justify="space-evenly" spacing={3}>                
                    
                    {/* CARD REPORTE CED01 (01 CEDENAR MULTIHOJA) */}
                    <Grid item xs={12} sm={5}>
                        <Typography variant="subtitle1" className={classes.sectionTitle}>Reporte Consolidado</Typography>
                        <Paper className={classes.contentPaper} elevation={0} variant="outlined">                                            
                            <Grid container justify="space-evenly" alignItems="center" spacing={1}>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" align="center" color="primary">01 Cedenar (.xlsx)</Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    {genCed01InProgress ? (
                                        <Grid container justify="center"><CircularProgress size={24} /></Grid>
                                    ) : (
                                        <Fab color="primary" size="small" variant="extended" classes={{ root: classes.uploadButton }} style={{ marginBottom: 10 }}
                                            onClick={() => callReportGeneration('ced01')}
                                        > 
                                            <Fragment><DonutLargeIcon /> {'Procesar'}</Fragment>                        
                                        </Fab>
                                    )}
                                </Grid>
                                <Grid item xs={4}>
                                    {downCed01InProgress ? (
                                        <Grid container justify="center"><CircularProgress size={24} /></Grid>
                                    ) : (
                                        <Fab color="primary" size="small" variant="extended" classes={{ root: classes.uploadButton }} style={{ marginBottom: 10 }}                                          
                                            onClick={() => downloadReport("ced01")}
                                        > 
                                            <Fragment><ArrowDropDownCircleIcon /> {'Descargar'}</Fragment>                        
                                        </Fab>      
                                    )}                                
                                </Grid> 
                            </Grid>                  
                        </Paper>
                    </Grid>

                    {/* CARD REPORTE SEMANAL MEM */}
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" className={classes.sectionTitle}>Reporte Semanal MEM</Typography>
                        <Paper className={classes.contentPaper} elevation={0} variant="outlined">                                            
                            <Grid container justify="center" alignItems="center" spacing={1}>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" align="center" color="primary">Descarga por Semanas (.xlsx)</Typography>
                                </Grid>
                                <Grid container justify="space-evenly" alignItems="center" spacing={1} style={{ marginTop: 5 }}>
                                    {Array.from({ length: weeksInCurrentMonth }, (_, i) => i + 1).map((weekNum) => (
                                        <Grid item key={weekNum}>
                                            {downloadingWeek === weekNum ? (
                                                <CircularProgress size={24} />
                                            ) : (
                                                <Fab 
                                                    color="primary" 
                                                    size="small" 
                                                    variant="extended" 
                                                    classes={{ root: classes.uploadButton }} 
                                                    style={{ marginBottom: 10 }}
                                                    onClick={() => downloadMemSemReport(weekNum)}
                                                > 
                                                    <Fragment>
                                                        <ArrowDropDownCircleIcon /> {`Semana ${weekNum}`}
                                                    </Fragment>                        
                                                </Fab>
                                            )}
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>                  
                        </Paper>
                    </Grid>

                    {/* NUEVO SECCIÓN: ANEXOS Y REPORTE DE CIERRE */}
                    <Grid item xs={12}>
                        <Typography variant="subtitle1" className={classes.sectionTitle}>Anexos y Detalles de Cierre MEM</Typography>
                        <Paper className={classes.contentPaper} elevation={0} variant="outlined">
                            <Grid container justify="space-evenly" alignItems="center" spacing={2}>
                                
                                {/* 1. Anexo Bolsa */}
                                <Grid item xs={12} sm={2}>
                                    <Typography variant="body2" align="center" color="primary" style={{ fontWeight: 'bold', marginBottom: 5 }}>Anexo Bolsa</Typography>
                                    <Grid container justify="center">
                                        {loadingAnexoBolsa ? (
                                            <CircularProgress size={24} />
                                        ) : (
                                            <Fab color="primary" size="small" variant="extended" classes={{ root: classes.uploadButton }}
                                                onClick={() => downloadAnexoReport('download-anexo-bolsa', setLoadingAnexoBolsa, 'Anexo_Bolsa')}
                                            >
                                                <Fragment><ArrowDropDownCircleIcon /> {'Descargar'}</Fragment>
                                            </Fab>
                                        )}
                                    </Grid>
                                </Grid>

                                {/* 2. Anexo Consumos */}
                                <Grid item xs={12} sm={2}>
                                    <Typography variant="body2" align="center" color="primary" style={{ fontWeight: 'bold', marginBottom: 5 }}>Anexo Consumos</Typography>
                                    <Grid container justify="center">
                                        {loadingAnexoConsumos ? (
                                            <CircularProgress size={24} />
                                        ) : (
                                            <Fab color="primary" size="small" variant="extended" classes={{ root: classes.uploadButton }}
                                                onClick={() => downloadAnexoReport('download-anexo-consumos', setLoadingAnexoConsumos, 'Anexo_Consumos')}
                                            >
                                                <Fragment><ArrowDropDownCircleIcon /> {'Descargar'}</Fragment>
                                            </Fab>
                                        )}
                                    </Grid>
                                </Grid>

                                {/* 3. Anexo Contratos */}
                                <Grid item xs={12} sm={2}>
                                    <Typography variant="body2" align="center" color="primary" style={{ fontWeight: 'bold', marginBottom: 5 }}>Anexo Contratos</Typography>
                                    <Grid container justify="center">
                                        {loadingAnexoContratos ? (
                                            <CircularProgress size={24} />
                                        ) : (
                                            <Fab color="primary" size="small" variant="extended" classes={{ root: classes.uploadButton }}
                                                onClick={() => downloadAnexoReport('download-anexo-contratos', setLoadingAnexoContratos, 'Anexo_Contratos')}
                                            >
                                                <Fragment><ArrowDropDownCircleIcon /> {'Descargar'}</Fragment>
                                            </Fab>
                                        )}
                                    </Grid>
                                </Grid>

                                {/* 4. Anexo Generación */}
                                <Grid item xs={12} sm={2}>
                                    <Typography variant="body2" align="center" color="primary" style={{ fontWeight: 'bold', marginBottom: 5 }}>Anexo Generación</Typography>
                                    <Grid container justify="center">
                                        {loadingAnexoGeneracion ? (
                                            <CircularProgress size={24} />
                                        ) : (
                                            <Fab color="primary" size="small" variant="extended" classes={{ root: classes.uploadButton }}
                                                onClick={() => downloadAnexoReport('download-anexo-generacion', setLoadingAnexoGeneracion, 'Anexo_Generacion')}
                                            >
                                                <Fragment><ArrowDropDownCircleIcon /> {'Descargar'}</Fragment>
                                            </Fab>
                                        )}
                                    </Grid>
                                </Grid>

                                {/* 5. Reporte Cierre */}
                                <Grid item xs={12} sm={2}>
                                    <Typography variant="body2" align="center" color="primary" style={{ fontWeight: 'bold', marginBottom: 5 }}>Reporte Cierre</Typography>
                                    <Grid container justify="center">
                                        {loadingReporteCierre ? (
                                            <CircularProgress size={24} />
                                        ) : (
                                            <Fab color="secondary" size="small" variant="extended" classes={{ root: classes.uploadButton }}
                                                onClick={() => downloadAnexoReport('download-reporte-cierre', setLoadingReporteCierre, 'Reporte_Cierre')}
                                            >
                                                <Fragment><ArrowDropDownCircleIcon /> {'Descargar'}</Fragment>
                                            </Fab>
                                        )}
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Paper>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="subtitle1" className={classes.sectionTitle}>Información Financiera</Typography>
                        <Paper className={classes.contentPaper} elevation={0} variant="outlined">
                            <Grid container justify="space-evenly" alignItems="center" spacing={2}>
                                
                                {/* 1. Anexo Bolsa */}
                                <Grid item xs={12} sm={2}>
                                    <Typography variant="body2" align="center" color="primary" style={{ fontWeight: 'bold', marginBottom: 5 }}>Reporte Información Financiera</Typography>
                                    <Grid container justify="center">
                                        {loadingInformacionFinanciera ? (
                                            <CircularProgress size={24} />
                                        ) : (
                                            <Fab color="primary" size="small" variant="extended" classes={{ root: classes.uploadButton }}
                                                onClick={() => downloadAnexoReport('download-informacion-financiera', setLoadingInformacionFinanciera, 'Reporte_Informacion_Financiera')}
                                            >
                                                <Fragment><ArrowDropDownCircleIcon /> {'Descargar'}</Fragment>
                                            </Fab>
                                        )}
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Paper>
                    </Grid>

                </Grid>   
            </Zoom>    
        </div>
    );
}